export default "https://cdn.msgboxx.io/static/media/clear-button.5b047e6f.png";